import { useMemo } from 'react';

export function useThreadCitations(events) {
  return useMemo(() => {
    const seen = new Map();
    for (const ev of events) {
      const seq = ev?.seq ?? ev?.stream_seq ?? null;
      const evType = ev?.event_type || ev?.type || '';
      let refs = [];
      if (evType === 'message.created' || evType === 'message') {
        // Exclude actor_id — it's an identifier, not a role; using it would
        // misclassify user events whose actor_id doesn't match 'user'/'human'.
        const role = ev?.body?.role || ev?.body?.author || ev?.body?.from || '';
        if (role !== 'user' && role !== 'human') {
          refs = ev?.body?.sourceRefs || [];
        }
      } else if (evType === 'context.assembled') {
        refs = ev?.Citations || ev?.body?.Citations || ev?.refs || [];
      }
      for (const urn of refs) {
        if (typeof urn !== 'string') continue;
        if (!urn.startsWith('urn:jobe:memory:') && !urn.startsWith('urn:jobe:episode:')) continue;
        if (!seen.has(urn)) {
          const kind = urn.startsWith('urn:jobe:episode:') ? 'episode' : 'memory';
          seen.set(urn, { urn, kind, seq });
        }
      }
    }
    return [...seen.values()];
  }, [events]);
}
